<script>
  import { createEventDispatcher, onMount, onDestroy, afterUpdate } from "svelte"
  import { timeAgo } from "../Script/time"
  import Audit from "./audit.svelte"

  const dispatch = createEventDispatcher()

  export let user = {}
  export let docStatus
  export let isModeNotSelected
  export let isESignPending
  export let isApproversFound
  export let signCnMismatchID

  // let APPROVER_CONDITION
  // let SIGNER_CONDITION

  let clickCount = 0

  let resendTimer
  let disableResendBtn = false

  let showActions = false

  const signedStatus = {
    "PFX-SIGN": "Digitally signed",
    "DSC-TOKEN-SIGN": "DSC Digitally signed (Dongle)",
    "E-SIGN": "eSigned",
    "AADHAAR-ESIGN": "Aadhaar eSigned",
  }

  const signMode = {
    "PFX-SIGN": "Digital Signing",
    "DSC-TOKEN-SIGN": "DSC Digital Signing (Dongle)",
    "E-SIGN": "ESign",
    "AADHAAR-ESIGN": "Aadhaar ESign",
  }

  onMount(() => {
    // if (user.status == "PENDING") {
    //   if (user.role == "APPROVER") {
    //     showActions = docStatus == "PENDING" && !isModeNotSelected
    //   } else {
    //     if (isModeNotSelected) {
    //       showActions = !user.internal && !user.mode ? true : false
    //     } else {
    //       if (docStatus == "APPROVED") {
    //         showActions = user.mode == "E-SIGN" || (user.mode != "E-SIGN" && !isESignPending)
    //       }
    //     }
    //   }
    // }
    // APPROVER_CONDITION = docStatus == "PENDING" && user.role == "APPROVER" && !isModeNotSelected
    // const ESIGNER = user.mode == "E-SIGN"
    // const OTHER_SIGNERS = user.mode != "E-SIGN" && !isESignPending
    // SIGNER_CONDITION = user.role == "SIGNER" && ((docStatus == "APPROVED" && (ESIGNER || OTHER_SIGNERS)) || (!user.mode && !user.internal))
  })

  afterUpdate(() => {
    if (user.status == "PENDING") {
      if (user.role == "APPROVER") {
        showActions = docStatus == "PENDING" && !isModeNotSelected
      } else {
        if (isModeNotSelected) {
          showActions = !user.internal && !user.mode ? true : false
        } else {
          if (docStatus == "APPROVED") {
            showActions = user.mode == "E-SIGN" || (user.mode != "E-SIGN" && !isESignPending)
          } else {
            showActions = false
          }
        }
      }
    }
  })

  onDestroy(() => {
    if (resendTimer) clearTimeout(resendTimer)
  })

  const handleCNMismatchApproval = () => {
    dispatch("cnameApproval")
  }
</script>

<li class="relative flex gap-x-4">
  <div class="relative flex w-9 justify-center">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div
      on:click={() => {
        let status = ["SIGNED", "REJECTED", "PUBLISHED", "COMPLETED"]
        if (user.internal || user.role == "APPROVER" || status.includes(docStatus) || (docStatus == "APPROVED" && isApproversFound)) return
        if (clickCount < 4) clickCount++
        else dispatch("modeSelect", { email: user.email, id: user.id, mode: user.mode ? signMode[user.mode] : "" })
      }}
      class="z-10 flex h-9 w-9 cursor-pointer items-center justify-center rounded-full text-white {user.status === 'PENDING' ? 'bg-yellow-500' : user.status === 'REJECTED' || user.id == signCnMismatchID ? 'bg-red-500' : 'bg-green-500'} p-3"
    >
      {#if user.id == signCnMismatchID}
        <i class="fa-solid fa-triangle-exclamation" />
      {:else}
        <i class="fa-solid {user.role === 'APPROVER' ? 'fa-file-signature' : 'fa-signature'}" />
      {/if}
    </div>
    <div class="absolute flex h-full w-1 bg-gray-500" />
  </div>

  <div class="text-xs/5 flex w-full flex-col gap-y-1 pb-6 text-gray-500">
    <div class="flex w-full items-center justify-between gap-3">
      {#if user.status == "PENDING"}
        <div class="wordBreak text-sm">
          Waiting for {user.role == "SIGNER" ? `${user.mode ? signMode[user.mode] : "Mode Selection"}` : "Approval"} from
          <strong class="text-gray-d00 dark:text-white">
            {user.name}
          </strong>
        </div>
      {:else}
        <div class="wordBreak text-sm font-semibold text-gray-d00 dark:text-white">
          {user.name}
          <span class="font-normal text-gray-500">
            {user.status === "SIGNED" ? signedStatus[user.mode] : user.status === "APPROVED" ? "Approved" : "Rejected"}.
          </span>
        </div>

        <div data-tooltip={new Date(user.timestamp).toLocaleString()} tooltip-position="left" class="min-w-fit cursor-pointer {user.status === 'REJECTED' ? 'text-red-500' : 'text-green-500'}">
          <span class="text-xs font-semibold">{timeAgo(user.timestamp)}</span>
        </div>
      {/if}
    </div>

    <div class="break-all font-semibold text-gray-400">{user.email}</div>

    {#if user.role == "SIGNER" && user.status == "SIGNED" && user.mode != "E-SIGN"}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div on:click class="mt-2 flex cursor-pointer items-center gap-2 text-xs font-semibold text-orange-500">
        <span>
          <i class="fa-solid fa-file-certificate text-sm" />
        </span>
        <span class="underline underline-offset-4">Digital Certificate Details</span>
      </div>
    {/if}

    {#if user.status != "PENDING" && user.tx}
      <Audit {user} />
    {/if}
    {#if user.id == signCnMismatchID && docStatus !== "REJECTED"}
      <span class="mt-2 text-sm font-semibold text-yellow-500">
        <i class="fa-solid fa-circle-info" />
        &nbsp;Signer name does not match with Common Name (CN) in the Digital Certificate Detalils.
      </span>

      <div class="mt-2">
        <button type="button" on:click={handleCNMismatchApproval} class="flex h-8 w-fit items-center justify-center rounded-md bg-blue-500 px-3 text-sm text-white">
          <span>
            <i class="fa-solid fa-triangle-exclamation" />
          </span>
          &nbsp;&nbsp;Approve CName Mismatch
        </button>
      </div>
    {/if}

    {#if showActions}
      <!-- {#if user.status == "PENDING" && (APPROVER_CONDITION || SIGNER_CONDITION)} -->
      <div class="mt-2 flex w-full flex-col gap-2">
        <div class="wordBreak text-sm">Share the {isModeNotSelected && !user.internal && !user.mode ? "Signing Preference" : "Invite"} Link</div>

        <div class="flex items-center gap-3">
          <button
            type="button"
            on:click={() => {
              const dispatchData = { email: encodeURIComponent(user.email), role: user.role }
              if (user.role == "SIGNER" && !user.internal && !user.mode) {
                dispatchData.mode = true
                dispatchData.name = encodeURIComponent(user.name)
              }
              dispatch("copy", dispatchData)
            }}
            class="flex h-8 w-fit items-center justify-center rounded-md bg-sky-500 px-3 text-sm text-white"
          >
            <span>
              <i class="fa-solid fa-copy" />
            </span>
            &nbsp;&nbsp;Copy
          </button>
          <button
            type="button"
            disabled={disableResendBtn}
            on:click={() => {
              disableResendBtn = true
              console.log(disableResendBtn)
              setTimeout(() => {
                disableResendBtn = false
              }, 31000)
              dispatch("sendInv", user.id)
            }}
            class="flex h-8 w-fit items-center justify-center rounded-md bg-green-500 px-3 text-sm text-white disabled:cursor-not-allowed disabled:bg-green-400"
          >
            <span>
              <i class="fa-solid fa-paper-plane-top" />
            </span>
            &nbsp;&nbsp;Resend
          </button>
        </div>
      </div>
    {/if}
  </div>
</li>
